import { useEffect, useState } from "react";
import type { Me } from "../types";
import { useMe } from "./use-me";

export const useRole = () => {
  const { data } = useMe();
  const [role, setRole] = useState<Me["role"]>(undefined);

  useEffect(() => {
    if (data?.role && data.role !== role) {
      setRole(data.role ?? null);
    }
  }, [data, role]);

  return {
    role,
  };
};
